import React from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../../components/modal/Dialog";

export const StorefrontDescriptionDialog = ({
  active,
  onDismiss,
  supplier,
}: {
  active: boolean;
  onDismiss: () => void;
  supplier: {
    description: string | null;
    Business: {
      registeredCompanyName: string | null;
      name: string;
      vatNumber: string | null;
      awrsNumber: string | null;
    };
  };
}) => {
  const { registeredCompanyName, name, vatNumber, awrsNumber } =
    supplier.Business;
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={`About ${name}`}
      />
      <DialogContent className={"flex flex-col gap-4"}>
        <p>{supplier.description}</p>
        <div className={"flex flex-col"}>
          {registeredCompanyName && (
            <p className={"text-sm text-zinc-500"}>{registeredCompanyName}</p>
          )}
          {vatNumber && (
            <p className={"text-sm text-zinc-500"}>VAT {vatNumber}</p>
          )}
          {awrsNumber && (
            <p className={"text-sm text-zinc-500"}>AWRS {awrsNumber}</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
